package br.com.texeratx.boardgametimeapp.data.model.login

import kotlinx.serialization.Serializable

@Serializable
data class UserDTO(
    val id: Long,
    val email: String,
    val displayName: String,
    val imageUrl: String? = null,
    val emailVerified: Boolean = false,
    val status: Int = 1,
    val createdAt: String? = null,
    val updatedAt: String? = null
)

@Serializable
data class UpdateUserRequest(
    val displayName: String? = null,
    val imageUrl: String? = null
)

@Serializable
data class ChangePasswordRequest(
    val currentPassword: String,
    val newPassword: String
)
